import { render, staticRenderFns } from "./editAdd.vue?vue&type=template&id=58d6bb90&scoped=true&"
import script from "./editAdd.vue?vue&type=script&lang=js&"
export * from "./editAdd.vue?vue&type=script&lang=js&"
import style0 from "./editAdd.vue?vue&type=style&index=0&id=58d6bb90&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6bb90",
  null
  
)

export default component.exports